<template>
  <div class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table table-lightborder table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Tienda</th>
          <th>Proveedor</th>
          <th>Fecha</th>
          <th>Fecha Creacion</th>
          <th>Usuario</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr
          @click="rowClick(current)"
          v-for="current in dataTabla.results"
          v-bind:key="current.id"
        >
          <td>{{ current.numero }}</td>
          <td>{{ current.tienda.nombre }}</td>
          <td>{{ current.proveedor.nombre }}</td>
          <td>{{ current.fecha }}</td>
          <td>
            <timeago
              :title="current.fecha_creacion"
              :datetime="current.fecha_creacion"
            ></timeago>
          </td>
          <td>
            <UsuarioEnTablaComponent :current="current.usuario" />
          </td>

          <td class="text-center">
            <div
              data-title="Activo"
              data-toggle="tooltip"
              v-html="current.estado_str"
            ></div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
    <PaginationComponent
      :currentPage="currentPage"
      :data="dataTabla"
      @pagechanged="onPageChange"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import CotizacionesService from "@/services/compras/CotizacionesService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  computed: {
    ...mapGetters({
      dataTabla: "cotizaciones/cotizaciones",
    }),
  },
  mounted() {
    this.$store.dispatch("cotizaciones/fetch");
  },
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "compras-cotizaciones-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "compras-cotizaciones-editar",
          params: { id: current.id },
        });
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("cotizaciones/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext,
      });
    },
    generar_orden_compra(current) {
      /**
       * Genera una COMPRA basada en LA COTIZACION
       */
      let self = this;
      CotizacionesService.generar_orden_compra(current.id)
        .then((response) => {
          Notifications.alert.confirm(
            "Orden de Compra Generada",
            "Ir a la Orden de Compra Generada",
            "",
            function () {
              self.$router.push({
                name: "compras-ordencompra-editar",
                params: { id: response.data.orden_compra_e },
              });
            }
          );
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
  },
};
</script>
